import React from "react";
import FunctionalPage from "./FunctionalPage";
import DashBoards from "../components/dashboard/DashBoards";
import {IS_HEAD, IS_SUPER_HEAD} from "../permissions/roleTypes";
import { useSelector } from "react-redux";
import { NotFound } from "./NotFoundPage";
import IframeEYBLearning from "../components/eyb-learning/IframeEYBLearning";

const EYBLearningPage = () => {
    const { roles } = useSelector((state) => state.currentUser);

    return (
        <>
            {IS_SUPER_HEAD(roles) && (
                <FunctionalPage component={<IframeEYBLearning
                    src={"https://enjoyiacademy.videastv.com/"}
                    title={"EYBLearning"}
                />} />
            )}

            {!IS_SUPER_HEAD(roles) && (
                <FunctionalPage title={""} component={<NotFound />} />
            )}
        </>
    );
};

export default EYBLearningPage;